module.exports = __webpack_public_path__ + "media/T01.de85968f.mp4";